/*
 * Generate an array of page numbers to display in the pagination component
 * @param page - The current page number
 * @param nbPages - The total number of pages
 * @returns An array of page numbers
 * if less than 8 pages, generate a simple array from 1 to 7
 * if more than 7 pages, generate a more complex array with ellipses
 */
export default function genPageOptions(page: number, nbPages: number) {
  let elementsToShow = 7
  let pageNumbers: (number | '...')[]
  if (elementsToShow > nbPages) elementsToShow = nbPages
  if(nbPages <= elementsToShow) {
    pageNumbers = Array.from({ length: elementsToShow }, (_, i) => i + 1)
  }
  else {
    if(page < 5) {
      pageNumbers = Array.from({ length: elementsToShow }, (_, i) => i + 1)
      pageNumbers[5] = '...'
      pageNumbers[6] = nbPages
    }
    else if(page > nbPages - 4) {
      pageNumbers = Array.from({ length: elementsToShow }, (_, i) => nbPages - 6 + i)
      pageNumbers[0] = 1
      pageNumbers[1] = '...'
    }
    else {
      pageNumbers = Array.from({ length: elementsToShow }, (_, i) => page - 3 + i)
      pageNumbers[0] = 1
      pageNumbers[1] = '...'
      pageNumbers[5] = '...'
      pageNumbers[6] = nbPages
    }
  }

  return pageNumbers
}